import React from "react";
import { Button, Modal } from "react-bootstrap";
import VisualisationTypeCardComponent from "./VisualisationTypeCardComponent";

import target_marketing from "../image/target_marketing.png";
import { visualisationTypes } from "../utils/viusalisationTypes";
import { useStore } from "../store";
import {useTranslation} from "react-i18next";

function VisualisationtypeModal(props: PropTypes) {
  const { t } = useTranslation("VisualisationtypeModal");
  const { visualisationType, setVisualisationType } = useStore();

  return (
    <Modal
      show={props.show}
      onHide={() => props.setShow(false)}
      size="xl"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {t("ModalTitle")}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1rem",
          justifyContent: "center",
        }}
      >
        {visualisationTypes.map((type, index) => (
          <VisualisationTypeCardComponent
            key={index}
            title={type.name}
            //description="Targeted Marketing. Targeted Marketing. Targeted Marketing. Targeted Marketing Targeted Marketing"
            image={type.image}
            onClick={() => props.setShow(false)}
          />
        ))}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => props.setShow(false)}>
          {t("CloseButton")}
        </Button>
        {/* <Button variant="primary">Save changes</Button> */}
        {/* ToDo add an input field to write visualisationtype */}
      </Modal.Footer>
    </Modal>
  );
}

type PropTypes = { show: boolean; setShow: (show: boolean) => void };

export default VisualisationtypeModal;